import React from 'react';
import '../styles/footer.css';

export default function Footer() {
    return (
        <footer className="footer" >
            <p>&copy; 2023 M.R. All rights reserved.</p>
        </footer>
    );
}
